export default "__VITE_ASSET__DzT1bRSc__"